import { render } from "./FooterBar.vue?vue&type=template&id=03ff2aeb&scoped=true"
const script = {}

import "./FooterBar.vue?vue&type=style&index=0&id=03ff2aeb&scoped=true&lang=css"

import exportComponent from "/home/hans/Proyectos/Clever/AlicaMedios/alicamedios.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03ff2aeb"]])

export default __exports__